const domain: string = 'CONTRACTS'

export const SAVE_CONTRACTS: string = `${domain}/SAVE_CONTRACTS`
